// Global Instructions Rule Applied!

/**
 * Extract company ID from a form value (object with value/id or raw string/number)
 */
export function extractCompanyId(companyValue: any): string | number | null {
  if (!companyValue) return null
  if (typeof companyValue === 'object') {
    return companyValue.value ?? companyValue.id ?? null
  }
  return typeof companyValue === 'string' && companyValue.trim() === '' ? null : companyValue
}
